import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const basicHeadingInput = basic.input({
    id: "basic-input-heading",
    label: "Heading",
    description: "A simple heading, use it to add a title to your page",
    content: withUniqueClass("h", (cls) => `<h2 class="${cls}">Write your heading here...</h2>`),
});